import { isValidNumber } from '../../../utils';

const getFillRate = (activePlacements, numOpenings) => {
  if (numOpenings === 0) {
    return '--';
  }
  if (isValidNumber(activePlacements) && isValidNumber(numOpenings)) {
    return Math.round((activePlacements * 100) / numOpenings);
  }
  return '--';
};

// Default export for the main utility
const dashboardHelpers = {
  getFillRate,
};

export default dashboardHelpers;
